import React,{createContext,lazy,Suspense,useCallback,useContext,useEffect,useRef,useState} from 'react';
import {useLocation,useNavigate} from 'react-router-dom';
import {useAuth} from '../../context/AuthContext';
import {workspaceEventFromKey} from './eventWorkspaceModel';
import {readReviewTarget} from '../overview/reviewTaskTarget';

const Context=createContext(null);
const NativeContext=createContext(null);
export const EventWorkspaceNativeProvider=NativeContext.Provider;
export const useEventWorkspaceLocalPlayer=()=>useContext(NativeContext);
const EventWorkspace=lazy(()=>import('./EventWorkspace'));
export const useEventWorkspace=()=>useContext(Context);

// The underlying Home stays mounted, including its week, scroll and filters.
export default function EventWorkspaceProvider({children,LocalPlayer}) {
  const {userData}=useAuth(),location=useLocation(),navigate=useNavigate();
  const [selection,setSelection]=useState(null),previousRoute=useRef(location.pathname);
  const open=useCallback((event,tab='prep',slotId='map-1',videoId=null,reviewTarget=null)=>{
    if(event?.__teamId&&event?.eventId)setSelection({uid:userData?.uid,event,tab,slotId,videoId,reviewTarget});
  },[userData?.uid]);
  const params=new URLSearchParams(location.search),shared=params.get('eventWorkspace');
  const teamId=params.get('calendarTeam')||params.get('teamId'),sharedEvent=workspaceEventFromKey(shared||'',teamId);
  useEffect(()=>{if(previousRoute.current!==location.pathname){previousRoute.current=location.pathname;setSelection(null);}},[location.pathname]);
  const close=()=>{
    setSelection(null);
    if(shared){const next=new URLSearchParams(location.search);['eventWorkspace','eventTab','eventVideo','eventNote','eventTime','eventTimeMode','eventNoteMode'].forEach(key=>next.delete(key));navigate({pathname:location.pathname,search:next.toString()?'?'+next:''},{replace:true});}
  };
  const selected=selection?.uid===userData?.uid?selection:sharedEvent?{event:sharedEvent.event,tab:params.get('eventTab')||'prep',slotId:sharedEvent.slotId,videoId:params.get('eventVideo'),reviewTarget:readReviewTarget(params)}:null;
  return <Context.Provider value={open}>{children}{selected&&userData?.uid&&<Suspense fallback={<p role="status">Opening event workspace…</p>}><EventWorkspace key={JSON.stringify([userData.uid,selected.event.__teamId,selected.event.eventId,selected.event.instanceDate])} {...selected} LocalPlayer={LocalPlayer} onClose={close}/></Suspense>}</Context.Provider>;
}
